import ImageViewer from "../protected/image-viewer";

export default ImageViewer;
